import { useState, useEffect } from "react";
import Swal from "sweetalert2";

import AxiosMain from "../../../components/layout/AxiosMain";
import { AppAPiUrl } from "../../../configs/appData";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ProductDetails from "./SalesOrderForm/ProductDetails";
import RequestPortingTime from "./SalesOrderForm/RequestPortingTime";
import ReviewTheSalesOrder from "./SalesOrderForm/ReviewTheSalesOrder";
import SelectNewNumber from "./SalesOrderForm/SelectNewNumber";
import SelectProduct from "./SalesOrderForm/SelectProduct";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import LoaderScreen from "../../../components/layout/LoaderScreen";

type StepAction = "review" | "selectnumber" | "porting";

interface Product {
  id: number;
  name: string;
  description: string | null;
  price: number;
  porting_enable: boolean;
  product_id: number | null;
  product_family: string | null;
  min_quantity: number | null;
  list_price: number | null;
  currency: string | null;
}

interface ProductsResponse {
  orderlines: Product[];
}

const stepsMap: Record<number, Record<number, StepAction>> = {
  3: {
    1: "review",
    2: "selectnumber",
    3: "porting",
    4: "selectnumber",
  },
  4: {
    2: "review",
    3: "review",
    4: "porting",
  },
  5: {
    4: "review",
  },
};

const handleSteps = (ccase: number, cstep: number): StepAction | undefined => {
  return stepsMap[cstep]?.[ccase];
};

const NewSalesOrderPage = (props: any) => {
  const { iComponetTranslate, setClose, selectedId, updateCount } = props;
  const [currentStep, setCurrentStep] = useState(1);
  const [currentCase, setCurrentCase] = useState(1);
  const [loading, setLoading] = useState(true);
  const [steps, setSteps] = useState<string[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [data, setData] = useState<any>();
  const action = handleSteps(currentCase, currentStep);
  const [updateLoading, setUpdateLoading] = useState(true);
  const [loaSamples, setLoaSamples] = useState([])

  const t = (name: string) => {
    const ifExist: any = iComponetTranslate.filter(
      (item: any) => item.label === name
    );
    if (ifExist.length > 0) {
      return ifExist[0].value
        ? ifExist[0].value
        : `No translate found (${ifExist[0].label})`;
    }
    return `No key found (${name})`;
  };

  const handleSubmit = async(send:Boolean) => {
    setLoading(true);
    const prevData = new Set(data.currentStep1);
      const filtered = products.filter((product) => prevData.has(product.id));
    const payload = {
      payload: data,
      count: 0,
      price: 0,
    };
    payload.count = filtered.length;
    if(selectedId){
      AxiosMain.patch(`${AppAPiUrl.AccountingSalesorderDraft}${selectedId}/`, payload).then((response)=>{
        if(send){
          AxiosMain.get(AppAPiUrl.SendSalesOrder.replace("<id>", selectedId)).then(()=>{
            Swal.fire({
              text: "Sales Order Created.",
              icon: "success",
              title: "Success",
            }).then(()=>{
              setClose();
            })
          }).catch((error)=>{
            console.log(error);
            Swal.fire({
              text: "Failed to Create Sales Order",
              icon: "error",
              title: "Error Occured",
            })
          })
        }
        else{
          Swal.fire({
            text: "Sales Order Updated Successfully! Do you want to close or continue working with the sales order",
            icon: 'success',
            confirmButtonText: "Continue",
            cancelButtonText: "Close",
            showCancelButton: true,
            confirmButtonColor: '#103256',
            cancelButtonColor: '#d33',
          }).then((result) => {
            if(!result.isConfirmed){
              setClose()
            }
          })
        }

      })
      .catch((error)=>{
        if (error.status === 403 && error.statusText === "Forbidden") {
          Swal.fire({
            title: "Permission Denied!",
            text: `Unable to get your Details`,
            icon: "error"
          })
        }
        else if (error.status === 401 && error.statusText === "Unauthorized") {
          Swal.fire({
            title: "Error",
            text: `Unauthorized`,
            icon: "error"
          })
        }
        else{
          Swal.fire({
            title: "Error",
            text: `Error:${error}`,
            icon: "error"
          })
        }   
      })
      .finally(()=>{
        setLoading(false);
        updateCount();
      })
    }
    else{
      AxiosMain.post(AppAPiUrl.AccountingSalesorderDraft, payload).then((response)=>{
        if(response.status === 201){
          setLoading(false);
          if(send){
            AxiosMain.get(AppAPiUrl.SendSalesOrder.replace('<id>', response.data.id)).then(()=>{
              Swal.fire({
                text: "Sales Order Created.",
                icon: "success",
                title: "Success",
              }).then(()=>{
                setClose();
              })
              .catch((error)=>{
                console.log(error);
                Swal.fire({
                  text: "Failed to Create Sales Order",
                  icon: "error",
                  title: "Error Occured",
                })
              })
            });
          }
          else{
            Swal.fire({
              text: "Sales Order Saved Successfully! Do you want to close or continue working with the sales order",
              icon: 'success',
              confirmButtonText: "Continue",
              cancelButtonText: "Close",
              showCancelButton: true,
              confirmButtonColor: '#103256',
              cancelButtonColor: '#d33',
            }).then((result) => {
              if(!result.isConfirmed){
                setClose()
              }
            })
          }
        }
      })
      .catch((error)=>{
        setLoading(false);
        if (error.status === 403 && error.statusText === "Forbidden") {
          Swal.fire({
            title: "Permission Denied!",
            text: `Unable to get your Details`,
            icon: "error"
          })
        }
        else if (error.status === 401 && error.statusText === "Unauthorized") {
          Swal.fire({
            title: "Error",
            text: `Unauthorized`,
            icon: "error"
          })
        }
        else{
          Swal.fire({
            title: "Error",
            text: `Error:${error}`,
            icon: "error"
          })
        }   
      })
      .finally(()=>{
        updateCount();
      })
    }
  }

  // Handle Form Submission
  const handleContinue = (submitData: object) => {   
    if (currentStep === 1){
      setData({...data, currentStep1:submitData});
      setLoading(true);
      handleCaseUpdate(1, submitData);
    }
    else if(currentStep === 2){
      setData({...data, "currentStep2": submitData});
      setLoading(true);
      handleCaseUpdate(2, submitData);
    }
    else if(currentStep === 3){
      setData({...data, "currentStep3":submitData});
    }
    else if(currentStep === 4){
      setData({...data, "currentStep4":submitData});
    }
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  // Load Products
  useEffect(()=>{
    const fetchProducts = async () => {
      try {
        const response = await AxiosMain.get<ProductsResponse>(AppAPiUrl.ResellerEnabledProducts);
        if(response.status === 200){
          const fetchedProducts = Array.isArray(response.data) ? response.data : [];
          setProducts(fetchedProducts);
        } else {
          console.error('Unexpected response status:', response.status);
          setProducts([]);
        }
      }
      catch (error: any){
        console.error('Error fetching products:', error);
        if (error.response) {
          if (error.response.status === 403 && error.response.statusText === "Forbidden") {
            Swal.fire({
              title: "Permission Denied!",
              text: `Unable to get your Details`,
              icon: "error"
            });
          }
          else if (error.response.status === 401 && error.response.statusText === "Unauthorized") {
            Swal.fire({
              title: "Error",
              text: `Unauthorized`,
              icon: "error"
            });
          } else {
            Swal.fire({
              title: "Error",
              text: `Failed to fetch products`,
              icon: "error"
            });
          }
        } else {
          Swal.fire({
            title: "Error",
            text: `Network error`,
            icon: "error"
          });
        }
        setProducts([]);
      }
    };

    fetchProducts();
    fetch_loa_samples();
  },[]);

  // Load Draft Data if selectedId exists
  useEffect(()=>{
    if(selectedId){
      AxiosMain.get(`${AppAPiUrl.AccountingSalesorderDraft}${selectedId}/`)
        .then((response)=>{
          if(response.status === 200){
            setData(response.data.payload || {});
            setUpdateLoading(false);
          }
        })
        .catch((error: any)=>{
          setUpdateLoading(false);
          console.error('Error fetching draft data:', error);
          if (error.response) {
            if (error.response.status === 403 && error.response.statusText === "Forbidden") {
              Swal.fire({
                title: "Permission Denied!",
                text: `Unable to get your Details`,
                icon: "error"
              });
            }
            else if (error.response.status === 401 && error.response.statusText === "Unauthorized") {
              Swal.fire({
                title: "Error",
                text: `Unauthorized`,
                icon: "error"
              });
            } else {
              Swal.fire({
                title: "Error",
                text: `Failed to fetch draft data`,
                icon: "error"
              });
            }
          } else {
            Swal.fire({
              title: "Error",
              text: `Network error`,
              icon: "error"
            });
          }
        })
    }
    setUpdateLoading(false);
  },[selectedId]);

  // Handle Cases
  useEffect(()=>{
    if(currentCase === 1){
      setSteps(["Step 1", "Step 2", "Step 3"]);
    }
    else if(currentCase ===2 || currentCase===3){
      setSteps(["Step 1", "Step 2", "Step 3", "Step 4"]);
    }
    else{
      setSteps(["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"]);
    }
  },[currentCase]);

  useEffect(()=>{
    if(products && Array.isArray(products)){
      setLoading(false);
    }
  },[products]);

  const handleCaseUpdate = (cstep:number, fdata:any) =>{
    let defaultCase = currentCase;
    if(cstep===1){
      const productMap: Map<number, Product> = new Map(
        products.map((product: Product) => [product.id, product])
      );
      defaultCase=1;
      for (const id of fdata) {
        const product = productMap.get(id);

        if (product && product.porting_enable === true) {
          defaultCase = 2;
          break;
        }
      }
    }
    else if(cstep===2){
      const { portings, quantities } = fdata;
      let portingCounter = 0;
      let totalQuantities = 0;

      for (const product of products) {
        if (product.porting_enable) {
          const productId = product.id;
          const portingValue = portings[productId] ?? 0;
          const quantityValue = quantities[productId] ?? 0;
          portingCounter += portingValue;
          totalQuantities += quantityValue;
        }
      }
      if (portingCounter === 0 && totalQuantities === 0) {
        defaultCase = 1;
      } else if (portingCounter === 0) {
        defaultCase = 2;
      } else if (portingCounter === totalQuantities) {
        defaultCase = 3;
      }
      else{
        defaultCase = 4;
      }
    }
    if(defaultCase !== currentCase){
      setCurrentCase(defaultCase);
    }
    setLoading(false);
  }
  
  // Handle Progress Steps
  const ProgressSteps = () => (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 2, my: 3 }}
      alignItems={"center"}
    >
      {steps.map(
        (step, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              color: currentStep >= index + 1 ? "#00AEEF" : "#ccc",
            }}
          >
           {currentStep <= index + 1 && <Box
              sx={{
                width: 41,
                height: 41,
                borderRadius: "50%",
                backgroundColor: currentStep === index + 1 ? "#00AEEF" : "#E0E0E0",
                margin: 2,
              }}
            />}
            {currentStep > index + 1 && <CheckCircleSharpIcon sx={{ fontSize: 48, m: 2 }} />}
            <Typography>{step}</Typography>
          </Box>
        )
      )}
    </Box>
  );

  const fetch_loa_samples = async() =>{
    try{
      const response = await AxiosMain.get(AppAPiUrl.LOASamples)
      if(response.status === 200){
        setLoaSamples(response.data)
      }
    }
    catch(error:any){
      console.error("Error occured while fetching, LOA samples", error)
    }    
  }

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="start"
        flexDirection="row"
        sx={{ m: 5 }}
      >
        <Box justifyContent="center" alignItems="center" width={'30vw'}>
          <Typography variant="h4" align="center" mt={12}>
            Create Sales Order
          </Typography>
          <ProgressSteps />
        </Box>
        {(loading || updateLoading) && (
          <Box sx={{ p: 4, width: '65vw' }}>
            <LoaderScreen msg="Loading..."/>
          </Box>
        ) }
        {!loading && !updateLoading && 
        <Box
          flexShrink={0}
          flexGrow={1}
          flexBasis="auto"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {/* Render components based on stage */}
          { currentStep === 1 && <SelectProduct handleContinue={handleContinue} products={products} data={data?.currentStep1} t={t} />}
          { currentStep === 2 && <ProductDetails handleContinue={handleContinue} handleBack={handleBack} products={products} data={data} t={t} />}
          { action === "selectnumber" && <SelectNewNumber handleContinue={handleContinue} handleBack={handleBack} products={products} data={data} t={t} />}
          { action === "porting" && <RequestPortingTime handleContinue={handleContinue} handleBack={handleBack} products={products} data={data} loaSamples={loaSamples} ccase={currentCase} t={t} />}
          { action === "review" && <ReviewTheSalesOrder handleBack={handleBack} handleSubmit={handleSubmit} products={products} data={data} t={t} />}
        </Box>
        }
      </Box>
    </>
  );
};

export default NewSalesOrderPage;
